import base from './base';
import palette from './palette';

const tooltip = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: palette.common.black,
        color: palette.common.white,
        fontSize: '10px',
        fontWeight: 400,
        padding: '3px 6px',
        borderRadius: base.shape.borderRadius,
      },
      arrow: {
        color: palette.common.black,
      },
    },
  },
};

export default tooltip;
